import { LocalStorageService } from "src/services";
import { LocalStorageKeys } from "src/enums";
import { UoM } from "src/types";

class UoMService {
  private static readonly DEFAULT_UOM_SETTING = "Metric";
  private readonly localStorageService: LocalStorageService;

  constructor(localStorageService: LocalStorageService) {
    this.localStorageService = localStorageService;
  }

  getLocalStorageUoMSetting(): UoM {
    try {
      return (
        this.localStorageService.getLocalStorageData<UoM>(LocalStorageKeys.UOM_SETTINGS) ??
        UoMService.DEFAULT_UOM_SETTING
      );
    } catch (error) {
      console.warn("Failed to get local storage UoM settings");
      return UoMService.DEFAULT_UOM_SETTING;
    }
  }

  setLocalStorageUoMSetting(uomSetting: UoM): void {
    try {
      this.localStorageService.setLocalStorageData<UoM>(LocalStorageKeys.UOM_SETTINGS, uomSetting);
    } catch (error) {
      console.warn("Failed to set local storage UoM settings");
    }
  }
}

export { UoMService };
